import cartFragment from './fragmentCart.gql';

const cartRetrieve = (
	`query ($id: ID!, $consent: VisitorConsent) @inContext(visitorConsent: $consent) {
	  node(id: $id) {
	  	id
	  	... on Cart ${cartFragment}
	  }
	}`
);

export default cartRetrieve;
